import React, { Component } from 'react';
import Fcard from './Fcard';
import { injectIntl, intlShape } from 'react-intl';

class Item extends Component {
  constructor() {
    super();
    this.state = {
      currentItemClicked: '',
    };
  }

  switchModal(clickedItem) {
    this.props.switchModal(clickedItem);
  }

  openNutritionInfo() {}

  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 column panel-card-outer ">
        <Fcard
          key={this.props.id}
          item={this.props}
          switchModal={clickedItem => this.switchModal(clickedItem)}
          openNutritionInfo={() => this.openNutritionInfo()}
        />
      </div>
    );
  }
}

Item.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Item);



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/Item.jsx